import { render, staticRenderFns } from "./wallet-extract.vue?vue&type=template&id=7952cbea"
import script from "./wallet-extract.vue?vue&type=script&lang=js"
export * from "./wallet-extract.vue?vue&type=script&lang=js"
import style0 from "./wallet-extract.vue?vue&type=style&index=0&id=7952cbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports